import {WindowService} from '../../service/window/window.service';
import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-agreement',
  templateUrl: './agreement.component.html',
  styleUrls: ['./agreement.component.scss']
})
export class AgreementComponent implements OnInit {

  constructor(
    private _windowServ: WindowService) {
  }

  ngOnInit() {
    this._windowServ.scrollTop();
  }
}



// WEBPACK FOOTER //
// /Users/mizunoe_jing/Documents/nice_day_current/bitbucket/starbright/src/app/pages/agreement/agreement.component.ts